import { render } from "./PhoneDepositView.vue?vue&type=template&id=6a578b98&scoped=true"
import script from "./PhoneDepositView.vue?vue&type=script&lang=js"
export * from "./PhoneDepositView.vue?vue&type=script&lang=js"

import "./PhoneDepositView.vue?vue&type=style&index=0&id=6a578b98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a578b98"]])

export default __exports__